import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderItemModel } from '@ov-suite/models-order';
import { FormBuilder } from '@angular/forms';
import _ from 'lodash';

@Component({
  selector: 'ov-suite-edit-line-note',
  templateUrl: './edit-line-note.component.html',
  styleUrls: ['./edit-line-note.component.css']
})
export class EditLineNoteComponent implements OnInit {
  @Input() selectedOrderItem: OrderItemModel;

  @Output() lineNoteOutput: EventEmitter<OrderItemModel> = new EventEmitter<OrderItemModel>();

  productSkuName: string;

  form = this.formBuilder.group({
    note: ['']
  });

  constructor(private readonly formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.productSkuName = this.selectedOrderItem.productSku.name;

    this.form.patchValue({
      note: this.selectedOrderItem.note || ''
    });

    this.form.valueChanges.subscribe(changes => {
      const updatedOrderItem = this.prepareUpdatedOrderItem(changes.note);
      this.lineNoteOutput.emit(updatedOrderItem);
    });
  }

  prepareUpdatedOrderItem(note: string) {
    const clone = _.cloneDeep(this.selectedOrderItem);
    clone.note = note;
    return clone;
  }
}
